import * as api from './base';

// 获取地址数据
export const getAddrInfo = (pId, cId) => api.get({
	url: `Address/AddressInfo?provinceId=${pId}&cityId=${cId}`,
	loading: ""
});

// 获取省列表数据
export const getProvince = () => api.get({
	url: "Address/AllProvinces",
	loading: ""
});

// 获取市列表数据
export const getCitys = (pId) => api.get({
	url: "Address/ProvincesCities?privinceId=" + pId,
	loading: ""
})

// 获取区列表数据
export const getAreas = (cId)=> api.get({
	url: "Address/CitysAreas?cityId=" + cId,
	loading: ""
})
